<div class="selector-div-wrapper">
  <span>Bestnode</span>
  <div class="form-check form-switch">
    <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="bestnode-switch"
      [(ngModel)]="tool.enabled" [checked]="tool.enabled">
  </div>
</div>